import { MIN_VALUE_PT } from '@/lib/units/unit-conversion'

/** Slider/input range is 0–359 so panel controls never wrap to an unexpected preset. */
export const ROTATION_SLIDER_MAX_DEG = 359
/** Minimum W/H in points — matches MIN_VALUE_PT (0.01 pt / 0p0.000833 / SHAPE_MIN_DIMENSION). */
export const MIN_DIMENSION = MIN_VALUE_PT
